import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export interface DeleteCommentTRPCInput {
  Id: string;
}

export const useDeleteCommentTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.comment.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.comment.commentsByConversationId.queryKey(),
        });
      },
    }),
  });

  return {
    deleteComment: async (
      input: DeleteCommentTRPCInput
    ): Promise<{ Id: string }> => mutation.mutateAsync(input),
    loading: mutation.isPending,
    error: mutation.error,
  };
};
